<div class="row page-header">
    <div class="col-12">
        <h1>
            Disciplinary Action
            <small>Manage employee disciplinary records</small>
        </h1>
    </div>
</div>
<div [hidden]="isInitialLoading">
    <div class="row">
        <div class="col-lg-12">
            <div class="row action-toolbar">
                <div class="col-12">
                    <form class="form-inline">
                        <action-toolbar-count [grid]="grid"></action-toolbar-count>
                        <action-toolbar-buttons
                            [grid]="grid"
                            [canEdit]="canEdit"
                            [showAdd]="true"
                            [showEdit]="true"
                            [showDelete]="true"
                            [showDuplicate]="false"
                        >
                        </action-toolbar-buttons>
                        <action-toolbar-search name="search" [(ngModel)]="grid.filter"></action-toolbar-search>
                        <grid-export [grid]="mainGrid" [name]="'Disciplinary Actions'"></grid-export>
                    </form>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <wj-flex-grid
                        id="mainGrid"
                        #mainGrid
                        appAutoSize
                        [padding]="73"
                        (initialized)="grid.initialize(mainGrid)"
                        (destroy)="grid.destroy()"
                        [itemsSource]="grid.view"
                    >
                        <wj-flex-grid-filter></wj-flex-grid-filter>
                        <wj-flex-grid-column
                            [header]="'Status'"
                            [binding]="'status'"
                            [width]="100"
                            [isReadOnly]="true"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Employee'"
                            [binding]="'employeeName'"
                            [width]="150"
                            [isReadOnly]="true"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'HrRef'" [binding]="'hrRef'" [width]="80" [isReadOnly]="true"></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Incident Date'"
                            [binding]="'date'"
                            [width]="100"
                            [isReadOnly]="true"
                            [format]="'d'"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Code'" [binding]="'code'" [dataMap]="codeMap" [width]="150" [isReadOnly]="true"></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Incident Description'"
                            [binding]="'incidentDesc'"
                            [minWidth]="250"
                            [width]="'*'"
                            [isReadOnly]="true"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Disciplinary Action'"
                            [binding]="'discAction'"
                            [minWidth]="200"
                            [width]="'*'"
                            [isReadOnly]="true"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Days Suspended'"
                            [binding]="'daysSuspended'"
                            [width]="100"
                            [isReadOnly]="true"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Warning'"
                            [binding]="'warningNoticeYn'"
                            [width]="100"
                            [isReadOnly]="true"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Progressive Discipline'"
                            [binding]="'udProgressiveDiscipline'"
                            [width]="150"
                            [isReadOnly]="true"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Follow-Up Date'"
                            [binding]="'followUpDate'"
                            [width]="110"
                            [isReadOnly]="true"
                            [format]="'d'"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Job Title'"
                            [binding]="'_jobTitle'"
                            [width]="130"
                            [isReadOnly]="true"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Created'"
                            [binding]="'createdOn'"
                            [width]="150"
                            [isReadOnly]="true"
                            [format]="'g'"
                        ></wj-flex-grid-column>
                    </wj-flex-grid>
                </div>
            </div>
        </div>
    </div>
</div>
